export default "__VITE_ASSET__Dvhz6rks__"